<template>
  <v-container class="pt-0" style="margin-bottom: 80px">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="title" />
      </v-col>
    </v-row>

    <v-row justify="center" style="margin-top: -55px">
      <v-col cols="12" md="9" class="d-flex justify-center pt-0">
        <v-card
          style="border-radius: 15px; padding: 15px; width: 90%"
          elevation="2"
        >
          <div class="text-caption grey--text mb-1">{{ $t("totalPoint") }}</div>
          <div class="d-flex align-center" style="gap: 8px">
            <PointSymbol
              :type="selectedPointType.point_type_type"
              :symbol="selectedPointType.point_type_symbol"
              :color="selectedPointType.point_type_color"
              :is_display="true"
              :outlined_box="false"
              :size="28"
            />
            <span
              class="font-weight-bold"
              style="font-size: 26px; line-height: 1"
              :style="{ color: site.color }"
            >
              {{ selectedPointType.point | commaPoint }}
            </span>
            <span class="text-body-2 black--text">{{
              selectedPointType.point_type_name
            }}</span>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="mt-0 pt-0">
        <v-img
          class="white--text align-end mx-auto"
          :src="require('@/assets/images/transfer-image.png')"
          max-width="350px"
        />
      </v-col>

      <v-form
        ref="transferForm"
        v-model="isFormValid"
        lazy-validation
        style="width: 100%; background-color: #ffffff"
      >
        <v-col cols="11" md="8" class="mx-auto pb-1 pt-2">
          <p class="py-0 ma-0 d-flex align-center">
            <v-icon class="mr-1">mdi-account</v-icon>
            {{ $t("selectMember") }}
          </p>
        </v-col>
        <v-col cols="11" md="8" class="mx-auto d-flex justify-center pb-0">
          <v-combobox
            v-model="selectMember"
            :items="dataListMember"
            :label="$t('selectMember')"
            outlined
            style="width: 350px"
            class="rounded-lg"
            item-text="data"
            return-object
            :rules="normalRules"
            hide-details
            required
          />
        </v-col>

        <!-- เลือกประเภท point (ถ้ามีมากกว่า 1) -->
        <template v-if="customerPoints.length > 1">
          <v-col cols="11" md="8" class="mx-auto pb-1 pt-4">
            <p class="py-0 ma-0">{{ $t("transferPointType") }}</p>
          </v-col>
          <v-col cols="11" md="8" class="mx-auto d-flex justify-center pt-0">
            <v-select
              v-model="selectedPointTypeId"
              :items="customerPoints"
              item-value="point_type_id"
              item-text="point_type_name"
              outlined
              style="width: 100%"
              class="rounded-lg"
              hide-details
            >
              <template #selection="{ item }">
                <div class="d-flex align-center" style="gap: 8px">
                  <PointSymbol
                    :type="item.point_type_type"
                    :symbol="item.point_type_symbol"
                    :color="item.point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="22"
                  />
                  <span>{{ item.point_type_name }}</span>
                </div>
              </template>
              <template #item="{ item }">
                <div class="d-flex align-center" style="gap: 8px; width: 100%">
                  <PointSymbol
                    :type="item.point_type_type"
                    :symbol="item.point_type_symbol"
                    :color="item.point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="22"
                  />
                  <span>{{ item.point_type_name }}</span>
                  <span class="ml-auto grey--text text-caption">{{
                    item.point | commaPoint
                  }}</span>
                </div>
              </template>
            </v-select>
          </v-col>
        </template>

        <template v-if="useExpire">
          <v-col cols="11" md="8" class="mx-auto pb-1 pt-4">
            <p class="py-0 ma-0">{{ $t("transferPointAmount") }}</p>
          </v-col>
          <v-col cols="11" md="8" class="mx-auto pt-0">
            <v-card outlined class="rounded-lg pa-3" style="width: 100%">
              <div
                v-for="(batch, index) in processedBatches"
                :key="batchKey(batch)"
                class="mb-2 pb-5"
                :style="{
                  paddingBottom: '10px',
                  borderBottom:
                    index !== processedBatches.length - 1
                      ? '1px solid #f0f0f0'
                      : 'none',
                }"
              >
                <div class="d-flex align-center mb-3">
                  <v-chip
                    label
                    :style="expireChipStyles(batch.point_expire_date)"
                    v-if="batch.point_expire_date"
                  >
                    {{
                      `${$t("expiredAt")} ${$options.filters.formatDate(
                        batch.point_expire_date
                      )}`
                    }}
                  </v-chip>

                  <span
                    class="text-caption grey--text ml-auto"
                    style="font-size: 14px !important"
                  >
                    {{ $t("remaining") }}: {{ batch.point | commaPoint }}
                  </span>
                </div>
                <div class="d-flex align-center" style="gap: 6px">
                  <v-btn
                    icon
                    outlined
                    @click="changeBatchAmount('minus', batch)"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                  <v-text-field
                    :value="transferAmounts[batchKey(batch)] || 0"
                    @change="setBatchAmount(batch, $event)"
                    type="number"
                    :min="0"
                    :max="batch.point"
                    outlined
                    dense
                    hide-details
                    class="transfer-amount-field"
                  />
                  <v-btn
                    icon
                    outlined
                    @click="changeBatchAmount('plus', batch)"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    :color="site.color"
                    dark
                    class="ml-1"
                    style="min-width: unset; font-size: 16px"
                    @click="setBatchAmount(batch, batch.point)"
                  >
                    {{ $t("max") }}
                  </v-btn>
                </div>
              </div>
              <div
                class="d-flex justify-space-between align-center mt-2 pt-2"
                style="border-top: 1px solid #e0e0e0"
              >
                <span class="text-md-body-1">{{ $t("total") }}</span>
                <span
                  class="font-weight-bold text-md-body-1"
                  :style="{ color: site.color }"
                >
                  {{ totalTransferPoint | commaPoint }}
                </span>
              </div>
            </v-card>
          </v-col>
        </template>

        <!-- จำนวน point: non-expire mode — single input -->
        <template v-else>
          <v-col cols="11" md="8" class="mx-auto pb-1 pt-4">
            <p class="py-0 ma-0">{{ $t("transferPointAmount") }}</p>
          </v-col>
          <v-col cols="11" md="8" class="mx-auto d-flex justify-center pt-0">
            <v-text-field
              :color="site.color"
              :label="$t('enterTransferPoints')"
              v-model.number="transferPoint"
              outlined
              required
              style="width: 350px"
              class="rounded-lg"
              :rules="transferRules"
              type="number"
            />
          </v-col>
        </template>
      </v-form>
    </v-row>

    <v-footer fixed app style="background-color: white">
      <v-col class="d-flex justify-center">
        <v-btn
          :color="site.color"
          class="white--text rounded-lg"
          :disabled="totalTransferPoint <= 0"
          @click="confirmTransfer"
          width="350"
        >
          {{ $t("transferPoints") }}
        </v-btn>
      </v-col>
    </v-footer>

    <!-- Confirm Dialog -->
    <v-dialog v-model="showConfirmDialog" max-width="360" persistent>
      <v-card class="rounded-xl">
        <v-card-text class="text-h6 text-center pt-5">
          {{ $t("transferPoints") }}
        </v-card-text>

        <v-card-text class="text-center pb-2">
          <div class="d-flex justify-center mb-4">
            <v-chip
              large
              class="px-4"
              :color="site.color + '1A'"
              style="
                height: auto;
                padding-top: 10px;
                padding-bottom: 10px;
                border-radius: 10px;
              "
            >
              <div class="d-flex align-center" style="gap: 10px">
                <PointSymbol
                  :type="selectedPointType.point_type_type"
                  :symbol="selectedPointType.point_type_symbol"
                  :color="selectedPointType.point_type_color"
                  :is_display="true"
                  :outlined_box="false"
                  :size="36"
                />
                <span
                  class="font-weight-bold"
                  style="font-size: 32px; line-height: 1"
                  :style="{ color: site.color }"
                >
                  {{ totalTransferPoint | commaPoint }}
                </span>
                <span class="text-body-1 black--text">{{
                  selectedPointType.point_type_name
                }}</span>
              </div>
            </v-chip>
          </div>

          <div class="text-caption grey--text mb-1">{{ $t("toMember") }}</div>
          <div class="font-weight-medium text-body-1">
            {{ selectMember.name }} {{ selectMember.surname }}
            <span class="text-caption grey--text">
              ({{ selectMember.phone }})
            </span>
          </div>
        </v-card-text>

        <v-card-actions class="pb-4 px-4">
          <v-container>
            <v-row>
              <v-col cols="6" class="text-center">
                <v-btn
                  :color="site.color"
                  class="rounded-lg"
                  outlined
                  block
                  @click="showConfirmDialog = false"
                >
                  {{ $t("cancel") }}
                </v-btn>
              </v-col>
              <v-col cols="6" class="text-center">
                <v-btn
                  :color="site.color"
                  class="rounded-lg white--text"
                  depressed
                  block
                  @click="onDialogConfirm"
                >
                  {{ $t("confirm") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import moment from "moment";
import HeaderTextBg from "@/components/headerTextBg.vue";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  components: { HeaderTextBg, PointSymbol },
  data: () => ({
    title: "transferPage",
    selectMember: "",
    dataListMember: [],
    isFormValid: true,
    normalRules: [(v) => !!v || "required"],
    selectedPointTypeId: null,
    transferPoint: 0,
    transferAmounts: {},
    showConfirmDialog: false,
  }),

  created() {
    if (!this.checkTransferPermission()) {
      this.$router.push({ name: "my-member" });
      return;
    }
    this.initialize();
    if (this.customerPoints.length) {
      this.selectedPointTypeId = this.customerPoints[0].point_type_id;
    }
  },
  methods: {
    checkTransferPermission() {
      if (this.site.account_type != "individual") {
        let detail = this.site.account_type_detail;
        if (detail.display_point == "team") {
          return false;
        } else if (
          detail.is_can_transfer_point == true &&
          detail.transfer_point_scope != null
        ) {
          if (detail.transfer_point_scope == "any_member") {
            return true;
          } else if (
            detail.transfer_point_scope == "leader" &&
            this.customer.parent_employee_id == null
          ) {
            return true;
          } else if (
            detail.transfer_point_scope == "member" &&
            this.customer.parent_employee_id != null
          ) {
            return true;
          } else if (detail.transfer_point_scope == "member_leader") {
            return true;
          } else {
            return false;
          }
        }
        return false;
      }
      return false;
    },

    async initialize() {
      try {
        const { data } = await Axios.get("getTransferMemberList");
        if (data?.status === "success") {
          this.dataListMember = (data.data || []).map((member) => ({
            ...member,
            data: `${member.phone} - ${member.name} ${member.surname}`,
          }));
          if (this.dataListMember.length === 1) {
            this.selectMember = this.dataListMember[0];
          }
        }
      } catch (err) {
        console.error("initialize[err]", err);
      } finally {
        this.isAppLoading(false);
      }
    },

    batchKey(batch) {
      return batch.point_expire_date || "none";
    },

    setBatchAmount(batch, value) {
      const key = this.batchKey(batch);
      const amount = Math.min(
        Math.max(Number(value) || 0, 0),
        Number(batch.point || 0)
      );
      this.$set(this.transferAmounts, key, amount);
    },

    changeBatchAmount(direction, batch) {
      const key = this.batchKey(batch);
      const current = Number(this.transferAmounts[key] || 0);
      const max = Number(batch.point || 0);
      const next =
        direction === "plus"
          ? Math.min(current + 1, max)
          : Math.max(current - 1, 0);
      this.$set(this.transferAmounts, key, next);
    },

    confirmTransfer() {
      if (!this.useExpire && !this.$refs.transferForm.validate()) return;
      if (this.totalTransferPoint <= 0) return;
      this.showConfirmDialog = true;
    },

    onDialogConfirm() {
      this.showConfirmDialog = false;
      this.saveTransfer();
    },

    saveTransfer() {
      this.isAppLoading(true);

      const payload = {
        employee_transfer: this.selectMember,
        point_type_id: this.selectedPointTypeId,
      };

      if (this.useExpire) {
        payload.transfer_point = this.processedBatches
          .map((batch) => ({
            point_expire_date: batch.point_expire_date || null,
            amount: Number(this.transferAmounts[this.batchKey(batch)] || 0),
          }))
          .filter((b) => b.amount > 0);
      } else {
        payload.transfer_point = [
          { point_expire_date: null, amount: this.transferPoint },
        ];
      }

      Axios.post("confirmTransferPoint", payload)
        .then(({ data }) => {
          if (data?.status === "success") {
            this.$swal.fire({
              icon: "success",
              text: this.$t("transferSuccess"),
              showConfirmButton: false,
              timer: 3000,
            });
            this.$store.dispatch("defaultSystem/getProfile");
            this.transferPoint = 0;
            this.transferAmounts = {};
          } else {
            this.$swal.fire({
              icon: "error",
              text: data?.message || this.$t("transferFailed"),
              confirmButtonColor: this.site.color,
            });
          }
        })
        .catch((err) => console.error("saveTransfer[err]", err))
        .finally(() => this.isAppLoading(false));
    },

    setAllBatchMax() {
      this.transferAmounts = this.processedBatches.reduce((acc, batch) => {
        acc[this.batchKey(batch)] = Number(batch.point || 0);
        return acc;
      }, {});
    },

    getExpireChipColorForDate(dateValue) {
      const palette = [
        "#D9F6A5",
        "#FFE0B2",
        "#BBDEFB",
        "#E1BEE7",
        "#FFCDD2",
        "#B2DFDB",
        "#FFF9C4",
      ];
      const len = palette.length;
      if (!dateValue) return palette[0];
      const m = moment(dateValue);
      const key = m.isValid() ? m.format("YYYY-MM-DD") : String(dateValue);
      const idx = this.expireDatePaletteIndexMap[key];
      return palette[idx % len];
    },

    expireChipStyles(dateValue) {
      return {
        backgroundColor: this.getExpireChipColorForDate(dateValue),
        color: "rgba(0, 0, 0, 0.87)",
      };
    },
  },

  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    useExpire() {
      return this.site.is_use_expire_coin === "Y";
    },

    customerPoints() {
      return Array.isArray(this.customer.point)
        ? this.customer.point.filter((p) => Number(p.point || 0) > 0)
        : [];
    },

    selectedPointType() {
      return this.customerPoints.find(
        (p) => Number(p.point_type_id) === Number(this.selectedPointTypeId)
      );
    },

    processedBatches() {
      const histories = this.selectedPointType?.separate_point_history || [];
      const cutoff = moment().add(10, "years");
      const withExpiry = [];
      const noExpiryGroup = [];

      histories.forEach((h) => {
        const isNoExpiry =
          !h.point_expire_date || moment(h.point_expire_date).isAfter(cutoff);
        if (isNoExpiry) noExpiryGroup.push(h);
        else withExpiry.push(h);
      });

      if (noExpiryGroup.length > 0) {
        const total = noExpiryGroup.reduce(
          (sum, h) => sum + Number(h.point || 0),
          0
        );
        withExpiry.push({ point: total, point_expire_date: null });
      }

      return withExpiry;
    },

    totalTransferPoint() {
      if (this.useExpire) {
        return Object.values(this.transferAmounts).reduce(
          (sum, v) => sum + Number(v || 0),
          0
        );
      }
      return Number(this.transferPoint || 0);
    },

    transferRules() {
      return [
        (v) => !!v || "กรุณากรอกจำนวนคะแนน",
        (v) => Number(v) > 0 || "ต้องมากกว่า 0",
        (v) =>
          Number(v) <= Number(this.selectedPointType.point || 0) ||
          `ต้องไม่เกิน ${this.selectedPointType.point} ${this.selectedPointType.point_type_name}`,
      ];
    },

    expireDatePaletteIndexMap() {
      const paletteLen = 7;
      const set = new Set();
      this.processedBatches.forEach((batch) => {
        if (!batch.point_expire_date) return;
        const m = moment(batch.point_expire_date);
        if (m.isValid()) set.add(m.format("YYYY-MM-DD"));
      });
      const sorted = [...set].sort();
      const map = Object.create(null);
      sorted.forEach((k, i) => {
        map[k] = i % paletteLen;
      });
      return map;
    },
  },

  watch: {
    selectedPointTypeId() {
      this.transferPoint = 0;
      this.transferAmounts = {};
    },
  },

  filters: {
    commaPoint(value) {
      const n = Number(value);
      if (!n) return "0";
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatDate(value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YYYY");
    },
  },
};
</script>

<style scoped>
.transfer-amount-field >>> .v-input__slot {
  min-height: 36px !important;
  border-radius: 6px !important;
}

.transfer-amount-field >>> input {
  text-align: center;
  font-weight: 700;
  padding: 2px 0 !important;
}
</style>
